import React from 'react'

const FiveM_formula = () => {
  return (
    <section className="container my-5">
        <div className="row">
            <div className="col-md-12">
                <h2 className="mb-3 myfont1 fw-bold">The 5 M Formula : Five Experts, One Goal, Stronger You</h2>
                <p className="text-muted">
                    Our unique 5 M Formula brings together Mentorship, Motivation, Mastery, Mindset, and Mission – the five pillars of personal and professional success.
                </p>
            </div>
        </div>
        <div className="row">
            <div className="col-md-2"></div>
            <div className="col-md-8 col-12">
                <img src="assets/images/5M_Formula.webp" alt="The 5 M Formula: Five Experts, One Goal, Stronger You infographic" className="img-fluid" loading="lazy"/>
            </div>
            <div className="col-md-2"></div>
        </div>
    </section>
  )
}

export default FiveM_formula